<template>
  <div/>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

const store = useStore<RootState>();

defineOptions({
  name: 'dataGlobalPairExchanges',
});

// Базовый тип для сообщений с глобальной парой и биржей
type GlobalPairExchangePair = {
  idGlobalPair: number;
  idExchange: number;
};

// Базовый тип для add/update операций глобальных пар-бирж
type GlobalPairExchangeAddUpdateData = GlobalPairExchangePair & {
  usage: unknown;
};

// Типы для WebSocket сообщений компонента globalPairExchanges
type GlobalPairExchangesListMessage = WebSocketMessageWithFields<'global-pair-exchange' | 'pair', {
  globalPairExchanges: unknown[];
}>;
type GlobalPairExchangeNotFoundMessage = WebSocketMessageEmpty<'global-pair-exchange-not-found'>;
type GlobalPairExchangeAddMessage = WebSocketMessageWithFields<'global-pair-exchange-add' | 'global-pair-exchange-add-success', GlobalPairExchangeAddUpdateData>;
type GlobalPairExchangeUpdateMessage = WebSocketMessageWithFields<'global-pair-exchange-update' | 'global-pair-exchange-update-success', GlobalPairExchangeAddUpdateData>;
type GlobalPairExchangeDeleteMessage = WebSocketMessageWithFields<'global-pair-exchange-delete' | 'global-pair-exchange-delete-success', GlobalPairExchangePair>;

// Объединенный тип для всех сообщений
type GlobalPairExchangesWebSocketMessage = 
  | GlobalPairExchangesListMessage 
  | GlobalPairExchangeNotFoundMessage 
  | GlobalPairExchangeAddMessage 
  | GlobalPairExchangeUpdateMessage 
  | GlobalPairExchangeDeleteMessage;

// WebSocket message handler
const handleWebSocketMessage = (data: GlobalPairExchangesWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'global-pair-exchange':
    case 'pair':
      store.dispatch('globalPairExchanges/wsSetGlobalPairExchanges', {globalPairExchanges: data.globalPairExchanges});
      break;
    case 'global-pair-exchange-not-found':
      store.dispatch('globalPair/wsSetEmptyGlobalPair');
      break;

    case 'global-pair-exchange-add':
    case 'global-pair-exchange-add-success':
      store.dispatch('globalPairExchanges/wsGlobalPairExchangeCreate', {
        idGlobalPair: data.idGlobalPair,
        idExchange: data.idExchange,
        usage: data.usage,
      });
      break;

    case 'global-pair-exchange-update':
    case 'global-pair-exchange-update-success':
      store.dispatch('globalPairExchanges/wsGlobalPairExchangeUpdate', {
        idGlobalPair: data.idGlobalPair,
        idExchange: data.idExchange,
        usage: data.usage,
      });
      break;

    case 'global-pair-exchange-delete':
    case 'global-pair-exchange-delete-success':
      store.dispatch('globalPairExchanges/wsGlobalPairExchangeDelete', {
        idGlobalPair: data.idGlobalPair,
        idExchange: data.idExchange,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);
</script>
